import { Component, OnInit } from '@angular/core';
import { Router, RouterModule } from '@angular/router';
import { PayrollService } from 'src/app/shared/services/payrollservices/payroll.service';
import { DashboardService } from 'src/app/shared/services/dashboardservices/dashboard.service';
import { SharedModeService } from 'src/app/shared/services/shared-mode.service';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { LoaderComponent } from 'src/app/shared/components/loader/loader.component';
@Component({
  selector: 'app-loan-detail',
  templateUrl: './loan-detail.component.html',
  styleUrls: ['./loan-detail.component.css'],
  standalone: true,
  imports: [CommonModule, FormsModule, LoaderComponent, RouterModule,]
})
export class LoanDetailComponent implements OnInit {
  showSpinner = false
  user: any;
  userInfo: any;
  colormode: any;
  selectedMode: any;
  datamode: any;
  constructor(
    public payrollService: PayrollService,
    public router: Router,
    public dashboardService: DashboardService,
    private sharedmode: SharedModeService,
  ) {
    this.user = JSON.parse(localStorage.getItem('user') || '');
    const user_role = JSON.parse(this.user.user_role.user_roles)
    if (user_role.role_type != "Admin") {
      this.router.navigate(['/dashboard-1']);
    }
    this.user_detail();
  }

  ngOnInit(): void {
    this.sharedmode.data$.subscribe(mode => {
      this.selectedMode = mode;
    });
  }
  toggleMode(mode: string) {
    this.datamode
    this.sharedmode.setMode(mode);
  }
  user_detail() {
    this.showSpinner = true;
    this.dashboardService.getuserdetail().then((value) => {
      this.userInfo = value.data
      this.colormode = this.userInfo.color_mode
      this.sharedmode.setMode(this.colormode);
      this.showSpinner = false;
    })

  }

}
